module.exports = __webpack_public_path__ + "img/carthaginians-empire.12f66ccc.png";